/**
 * True when a router URL is the full chat page.
 *
 * Exact match or a child route — deliberately not a `startsWith('/chat')`, which would also
 * swallow unrelated paths like `/chat-settings`.
 *
 * Shared by the launcher and the header trigger: both hide themselves on `/chat`, and when the
 * test lived privately in one of them the other could disagree about what "on the chat page"
 * means.
 */
export function isChatUrl(url: string): boolean {
  const path = (url || '').split('?')[0].split('#')[0];
  return path === '/chat' || path.startsWith('/chat/');
}
